import { FC } from "react";
import { CustomDayCellProps } from "..";
import Text from "../../../../../components/Text";

import Stat from "../../../../../components/Text/Stat";
import { useJournalSettings } from "../../../../../services/journalSettings";
import { Session } from "../../../../../types/Session";
import cellStyles from "../styles.module.scss";
import styles from "./styles.module.scss";

const TradingDay: FC<CustomDayCellProps> = (props) => {
    const {
        sessions,
        hidePerformance,
        onEmptyWeekdayClick: _omitEmptyClick,
        isEmptyCalendarDayAddAllowed: _omitPred,
        ...rest
    } = props;
    const { challengeMoneyManagement } = useJournalSettings();

    const sessionTotal = sessions.reduce(
        (total, session) => total + session.total,
        0
    );
    const totalTrades = sessions.reduce(
        (total, session) =>
            total + ("Trade" in session ? session.Trade.length : 0),
        0
    );
    const tradingSessions = sessions.filter(
        (session): session is Session => "Trade" in session
    );
    const hasChallenge = tradingSessions.some(
        (session) => session.moneyManagement === challengeMoneyManagement
    );
    const hasBuy = tradingSessions.some(
        (session) => session.sessionType === "buy"
    );
    const hasSell = tradingSessions.some(
        (session) => session.sessionType === "sell"
    );
    const hasDayTrading = tradingSessions.some(
        (session) => session.tradingStyle === "day_trading"
    );
    const hasScalping = tradingSessions.some(
        (session) => session.tradingStyle === "scalping"
    );
    const tradingStyleBadge =
        hasDayTrading && hasScalping
            ? "DT/SC"
            : hasDayTrading
              ? "DT"
              : hasScalping
                ? "SC"
                : null;
    const maskedPerformanceLabel =
        sessionTotal > 0 ? "Gain" : sessionTotal < 0 ? "Perte" : "Neutre";
    const maskedPerformanceClass =
        sessionTotal > 0
            ? styles.maskedPerformanceGain
            : sessionTotal < 0
              ? styles.maskedPerformanceLoss
              : styles.maskedPerformanceNeutral;
    const isStraddleOutside = Boolean(
        rest.className?.includes("rdp-outside") && sessions.length > 0
    );
    const amountStraddleClass = isStraddleOutside
        ? sessionTotal > 0
            ? cellStyles.amountStraddlePaleProfit
            : sessionTotal < 0
              ? cellStyles.amountStraddlePaleLoss
              : cellStyles.amountStraddlePaleFlat
        : "";

    return (
        <div {...rest}>
            <div className={styles.customDayCellContent}>
                <div className={styles.topCase}>
                    <Text className={styles.dayNumber} variant="body">
                        {rest.day.date.getDate()}
                    </Text>
                    {hidePerformance ? (
                        <Text
                            variant="body-bold"
                            className={`${styles.maskedPerformance} ${maskedPerformanceClass}`}
                        >
                            {maskedPerformanceLabel}
                        </Text>
                    ) : (
                        <Stat
                            variant="body-bold"
                            className={`${styles.total} ${amountStraddleClass}`.trim()}
                            type="currency"
                        >
                            {Number(sessionTotal.toFixed(2))}
                        </Stat>
                    )}
                </div>
                {(tradingStyleBadge ||
                    (!hidePerformance &&
                        (hasChallenge || hasBuy || hasSell))) && (
                    <div className={styles.dayMeta}>
                        {tradingStyleBadge && (
                            <span
                                className={styles.tradingStyleBadge}
                                title={
                                    hasDayTrading && hasScalping
                                        ? "Day trading / Scalping"
                                        : hasDayTrading
                                          ? "Day trading"
                                          : "Scalping"
                                }
                            >
                                {tradingStyleBadge}
                            </span>
                        )}
                        {!hidePerformance && hasChallenge && (
                            <span className={styles.challengeBadge}>
                                🎯 Chall
                            </span>
                        )}
                        {!hidePerformance && hasBuy && (
                            <span
                                className={`${styles.directionTriangle} ${styles.buyTriangle}`}
                                role="img"
                                aria-label="Trade à l'achat"
                                title="Achat"
                            />
                        )}
                        {!hidePerformance && hasSell && (
                            <span
                                className={`${styles.directionTriangle} ${styles.sellTriangle}`}
                                role="img"
                                aria-label="Trade à la vente"
                                title="Vente"
                            />
                        )}
                    </div>
                )}
                <Text variant="caption" className={styles.sessionCount}>
                    {`${sessions.length} session(s)`}
                </Text>
                <Text variant="caption" className={styles.tradeCount}>
                    {`${totalTrades} trade(s)`}
                </Text>
            </div>
        </div>
    );
};

export default TradingDay;
